<template>
  <v-container fluid pa-0>
    <v-tabs
      v-model="tab"
      color="grey darken-4"
      class="pa-2"
    >
      <v-tabs-slider color="white"></v-tabs-slider>
      <!-- TAB 1 -->
      <v-tab class="caption" href="#tab-1">
        Creación minutas de servicio
      </v-tab>
      <!-- TAB 2 -->
      <v-tab class="caption" href="#tab-2">
        Visualización minutas de servicio
      </v-tab>
      <!-- TAB 3 -->
      <v-tab v-if="adminRole !== null" class="caption" href="#tab-3">
        Misiones Base
      </v-tab>
      <!-- TAB 1 CONTENT -->
      <v-tab-item value="tab-1">
        <create-mission-view />
      </v-tab-item>
      <!-- TAB 2 CONTENT -->
      <v-tab-item value="tab-2">
        <missions-viewer />
      </v-tab-item>
      <!-- TAB 3 CONTENT -->
      <v-tab-item v-if="adminRole !== null" value="tab-3">
        <base-missions />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import CreateMissionView from './CreateMissionView'
import MissionsViewer from './MissionsViewer'
import BaseMissions from './BaseMissions'

export default {
  name: 'missions-services',
  components: {
    MissionsViewer,
    CreateMissionView,
    BaseMissions
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    ...mapGetters({
      adminRole: 'auth/adminRole',
      role: 'auth/role'
    })
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Missions/MissionsServices.vue